import _ from 'lodash';
import React, { Component, ReactComponentElement } from 'react';
import LiteralsService from '../../../services/literals/LiteralsService';
import NavigationService from '../../../services/navigation.service';

import { ButtonPrimary, ButtonSecondary } from '@americanexpress/dls-react';
import './SavingsBottomsButtons.scss';

export default class SavingsBottomButtons extends Component<any> {
    /// ////////////////
    // Onced Methods //
    /// ////////////////
    private readonly handleDeleteOnce: () => void = _.once(async () => {
        await this.props.handleDeleteCard(this.props.drawerProps.card);
        await NavigationService.goBack(this.props.drawerProps.history);
    });

    public override render(): ReactComponentElement<any> {
        const view: JSX.Element = (
            <div className="savings-bottom-buttons-container buttons">
                <ButtonPrimary
                    disabled={this.props.disabled}
                    onClick={async () => {
                        if (this.props.canSubmit && !this.props.canSubmit()) return;
                        this.props.drawerProps.card.attributes.started = 'true';
                        await this.props.handleUpdateCard();
                        await NavigationService.goBack(this.props.drawerProps.history);
                        if (this.props.afterUpdateAction) this.props.afterUpdateAction();
                    }}
                >
                    {LiteralsService.getLiteral('SavingsDrawer.update')}
                </ButtonPrimary>
                <ButtonSecondary
                    onClick={async () => {
                        await this.props.handleDeleteCard(this.props.drawerProps.card);
                        await NavigationService.goBack(this.props.drawerProps.history);
                    }}
                >
                    Delete
                </ButtonSecondary>
            </div>
        );

        return view;
    }
}
